<template>
  <Head title="Login" />
  <div class="container-fluid vh-100">
    <div class="row h-100">
      <div class="col-md-6">
        <div class="logo-wrapper">
          <logo class="logo mx-auto mb-3" width="300" height="50" />
        </div>
        <form class="bg-white p-3 w-50 mx-auto shadow" @submit.prevent="login" style="width: 65% !important">
          <div class="px-10 py-12">
            <h1 class="text-center text-3xl font-bold">Welcome Back!</h1>
            <div class="mt-6 mx-auto w-24 border-b-2" />
            <text-input v-model="form.email" :error="form.errors.email" class="mt-10" label="Email" type="email" autofocus autocapitalize="off" />
            <text-input v-model="form.password" :error="form.errors.password" class="mt-6" label="Password" type="password" />

            <div class="form-check form-check-inline mb-3">
              <input class="form-check-input" type="checkbox" v-model="form.remember" id="remember">
              <label class="form-check-label" for="remember">
                Remember Me
              </label>
            </div>
            <div class="form-check form-check-inline mb-3">
              <a href="mailto:reservations@airsxm.com?subject=I want to become an agent" class="form-check-label">
                Want to become an Agent?
              </a>
            </div>
          </div>
          <div class="">
            <loading-button :loading="form.processing" class="btn btn-primary ml-auto" type="submit">Login</loading-button>
          </div>
        </form>
      </div>
      <div class="col-md-6 bg-primary">

      </div>
    </div>
  </div>
</template>

<script>
import { Head } from '@inertiajs/inertia-vue3'
import Logo from '@/Shared/Logo'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  components: {
    Head,
    LoadingButton,
    Logo,
    TextInput,
  },
  data() {
    return {
      form: this.$inertia.form({
        email: '',
        password: '',
        remember: false,
      }),
    }
  },
  methods: {
    login() {
      this.form.post('/login')
    },
  },
}
</script>

<style lang="scss">
.logo-wrapper {
  text-align: center;
}

.logo {
  width: 200px;

  g, path, text {
    fill: var(--bs-primary);
  }
}
</style>
